import { render, staticRenderFns } from "./itemReleaseDetailList.vue?vue&type=template&id=03754943&scoped=true"
import script from "./itemReleaseDetailList.vue?vue&type=script&lang=js"
export * from "./itemReleaseDetailList.vue?vue&type=script&lang=js"
import style0 from "./itemReleaseDetailList.vue?vue&type=style&index=0&id=03754943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03754943",
  null
  
)

export default component.exports